import { render, staticRenderFns } from "./WorkIconNavCollapse.vue?vue&type=template&id=bc4bb7ba"
import script from "./WorkIconNavCollapse.vue?vue&type=script&lang=js"
export * from "./WorkIconNavCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports